import $ from 'jquery'

global.$ = $;
global.jQuery = $;
window.$ = $;

global.bootstrap = window.bootstrap = require('bootstrap')

//import * as Sentry from "@sentry/browser";
//import { BrowserTracing } from "@sentry/tracing";


require('./components/CmsSelect2');
//require('../../../Framework/assets/js/cms-datepicker');
require('./cms-datepicker');
//require('../../../Framework/assets/js/cms-ajax-form');
require('/Project/Framework/assets/js/cms-ajax-form.js');
//require('./cms-element-duplicator');
require('./components/CmsFormConditions')
require('../../../Modules/Captcha/assets/js/cms-captcha')
require('../../../Framework/assets/js/cms-password')
require('../../../Project/Modules/Media/assets/media');
require('../../../Project/Modules/Attributes/assets/js/applicant_address')
require('../../../Project/Modules/Attributes/assets/js/attribute_project_timeframe')
require('../../../Project/Modules/General/assets/js/wrap')
require('./disable-empty-filter-fields')
require('./accordion-init')
require('./fancybox-init')
require('./popover-init')
require('./tooltip-init')
require('./form-helpers')
require('./modal-init')
require('./collection-init')
require('./carousel-init')
require('./table-orderable')
require('./content')
require('./autocomplete');
require('./components/tabsSelection')
require('/Project/Modules/Lists/assets/List/ListInput')
require('/Project/Modules/Lists/assets/List/ListView')
require('/Modules/Rules/assets/js/rules')
require('./components/table')
require('./components/WidgetSlider')
require('./components/side-form-navigation')
require('./form-accordion')
require('./font-size-change')
require('./components/ActionConfirmation')
require('./components/ConfirmModal')
require('./components/PhoneInput')
require('./components/MemberForm')
require('./components/MemberRemoveForm')
require('./components/ApplicationForm')
require('./components/ApplicationUserForm')
require('./components/ApplicationJoinForm')
require('./components/JoinForm')
require('./components/ProfileForm')
require('./components/AppVerificationStatus')
require('./components/Select2Search')
require('./components/Reports')



window.checkRulesAgreement = function () {
    $("[name='agree_rules']").each(function () {
        this.checked = true
    })
    Fancybox.close();
}

$(document).on('alert.auto-dismiss', function (e) {
    $('.alert[data-auto-dismiss="true"]').each(function () {
        let $alert = $(this);
        setTimeout(function () {
            $alert.fadeTo(250, 0.5).slideUp(250);
        }, 5000);
    });
});
$(document).on('click', '[data-reload-location]', function (e){
    window.location.reload()
})

$('[data-reload-after]').each(function (){
    setTimeout(function (){
        window.location.reload()
    }, $(this).data('reload-after'))
})


$(document).on('click', '.toggle-all', function (e) {
    e.preventDefault();

    var $btn = $(this);

    var labelExpand = $btn.attr('data-label-expand');
    var labelCollapse = $btn.attr('data-label-collapse');

    var currentLabel = $.trim($btn.text());

    if (currentLabel === labelCollapse) {
        var $expandedItems = $('.accordion .accordion-collapse.show');
        if ($expandedItems.length > 0) {
            $expandedItems.collapse('hide');
            $btn.text(labelExpand);
        }
    } else {
        var $collapsedItems = $('.accordion .accordion-collapse:not(.show)');
        if ($collapsedItems.length > 0) {
            $collapsedItems.collapse('show');
            $btn.text(labelCollapse);
        }
    }
});

// Accessibility select2 fix
$(function () {
    $('.select2-search__field').each(function (i) {
        var $s = $(this);
        var txt = $s.closest('.form-group').find('label').first().text().trim() || 'Search';
        $s.attr('aria-label', txt);
    });
});

$('#show-more-btn').on('click', function () {
    $('#items-list .extra-item')
        .removeClass('d-none')
        .hide()
        .slideDown(200);
    $(this).remove();
});


//region Reports
const $table = $('#reportTabContent #tab-citizenship table');
const columnCount = $table.find('tr:first > *').length;

for (let col = 1; col < columnCount - 1; col++) {
    const nth = col + 1;
    // Tik duomenų langeliai tikrinimui
    const $cells = $table.find(`tbody tr > *:nth-child(${col + 1})`);

    const allZero = $cells.length > 0 && $cells.toArray().every(cell => {
        const value = parseFloat(
            $(cell).text().trim().replace(',', '.')
        );

        return !isNaN(value) && value === 0;
    });

    if (allZero) {
        // Paslepiam ir thead, ir tbody stulpelį
        $table.find(`tr > *:nth-child(${nth})`).hide();
    }
}
$('#reportTabContent table').removeClass('d-none');
//endregion Reports
